"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const HighlightedText = ({ text, searchTerm, className = '' }) => {
    // Pokud není vyhledávací termín, vrátíme obyčejný text
    if (!searchTerm || searchTerm.trim() === '') {
        return (0, jsx_runtime_1.jsx)("span", { className: className, children: text });
    }
    const trimmedSearchTerm = searchTerm.trim();
    // Rozdělíme text podle vyhledávaného termínu (case-insensitive)
    const parts = text.split(new RegExp(`(${trimmedSearchTerm})`, 'gi'));
    return ((0, jsx_runtime_1.jsx)("span", { className: className, children: parts.map((part, index) => {
            // Pokud část odpovídá vyhledávanému termínu, zvýrazníme ji
            if (part.toLowerCase() === trimmedSearchTerm.toLowerCase()) {
                return ((0, jsx_runtime_1.jsx)("mark", { className: "bg-yellow-200 text-yellow-900 px-1 rounded font-medium", style: {
                        backgroundColor: '#fef08a',
                        color: '#92400e',
                        padding: '2px 4px',
                        borderRadius: '3px',
                        fontWeight: '600'
                    }, children: part }, index));
            }
            return part;
        }) }));
};
exports.default = HighlightedText;
